module.exports = __webpack_public_path__ + "ea0dd09750aaf6ab7ed8399f696d7f26.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/VI.svg
// module id = GUUl
// module chunks = 0